import {Service, service} from "./di";
import { isCrawler } from "../utils/crawler";

type ICache = { [key: string]: string };
@service("storageService")
export class StorageService extends Service {

	cache: ICache = {};

	get available() {
		let ok = true;
		try {
			localStorage.setItem("storageCheck", "");
			localStorage.removeItem("storageCheck");
		} catch (e) {
			ok = false;
		}
		return ok;
	}

	setItem(key: string, value: string) {
		try {
			if (isCrawler()) {
				this.cache[key] = value;
			} else {
				localStorage.setItem(key, value);
			}
			return true;
		} catch (e) {
			console.error(`Error setting item in localeStorage: ${e.message}`);
			return false;
		}
	}

	getItem(key: string): any {
		try {
			return isCrawler() ? this.cache[key] : localStorage.getItem(key);
		} catch (e) {
			console.error(`Error getting item from localeStorage: ${e.message}`);
			return undefined;
		}
	}

	removeItem(key: string) {
		try {
			if (isCrawler()) {
				delete this.cache[key];
			} else {
				localStorage.removeItem(key);
			}
		} catch (e) {
			console.error(`Error removing item from localeStorage: ${e.message}`);
		}
	}
}
